module.exports = __webpack_public_path__ + "static/img/2_05.c4b8f27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/03/2_05.jpg
// module id = LloQ
// module chunks = 1